import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AFEntity, SignInModel } from '../model/af.model';
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { ChangeLoginEvent, ShowLoaderEvent } from '../service/events';

@Injectable({
  providedIn: 'root'
})

export class AuthguardNHP {

  constructor(private userService: AuthService, private router: Router, private eventBus: EventService) {
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {

    const verifyId: string = route.queryParams['verifyId'];
    const token: string = route.queryParams['token'];
    if (verifyId != null) {
      sessionStorage.setItem('verifyId', verifyId);
      localStorage.setItem('verifyIdLocal', verifyId);
      sessionStorage.setItem('nhpToken', token);

    } else if (this.userService.getVerifyId() == null) {
      this.router.navigate(['unauthorized']);
    }

    this.userService.validateNHPToken(token, verifyId).subscribe({
      next: () => {
        this.userService.getApplicantDetails(true).subscribe({
          next: (data: AFEntity) => {
            sessionStorage.setItem(environment.user_object, JSON.stringify(data));
            let signInModel = new SignInModel();
            signInModel.nhpSign = true;
            signInModel.username = this.userService.getUser().email;
            signInModel.verifyId = this.userService.getVerifyId();
            this.userService.signIn(signInModel).subscribe({
              next: () => {
                this.eventBus.emit(new ShowLoaderEvent({ show: true }));
                this.eventBus.emit(new ChangeLoginEvent({ afEntity: this.userService.getUser() }));
                this.router.navigate(['introduction']);
              },
              error: () => {
                this.router.navigate(['unauthorized']);
                this.eventBus.emit(new ShowLoaderEvent({ show: true }));
              }
            });
          },
          error: () => {
            this.router.navigate(['unauthorized']);
            this.eventBus.emit(new ShowLoaderEvent({ show: true }));
          }
        });

      },
      error: () => {
        this.router.navigate(['unauthorized']);
        this.eventBus.emit(new ShowLoaderEvent({ show: true }));
      }
    });

    this.eventBus.emit(new ShowLoaderEvent({ show: false }));

    return true;
  }
}
